import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["callback"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect } from 'react';
import App from '../App';
import { setCallback } from '../../../../utils/CallbackUtils/index';
import { ThemeProvider } from 'styled-components';
import { themes, createTheme } from '@chegg-ui/theme';
var Coupon = function Coupon(_ref) {
  var callback = _ref.callback,
    appProps = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    setCallback(callback, 'COUPON');
  }, []);
  var horizonTheme = createTheme({}, themes.horizon);
  appProps = _objectSpread({}, appProps);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: horizonTheme
  }, /*#__PURE__*/React.createElement(App, appProps));
};
export default /*#__PURE__*/React.memo(Coupon);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Coupon/views/Coupon/index.js
// module id = 3503
// module chunks = 11